"use client";

import Link from "next/link";

import { Button } from "@/components/ui/elements/button";
import { ArrowForwardIcon } from "@/components/ui/elements/icon";

import { HOME_BRAND_COLOR } from "./_constants/home";
import classes from "./_css/Home.module.css";

type Props = {
  /** ログイン状態の判定に使う。null なら未ログイン */
  authToken: string | null;
  /** 未ログイン時にログイン導線を併記するか */
  withLoginLink?: boolean;
  /** e2e 用の testid を付けるか。ページ内で一意にするためヒーローの CTA にだけ付ける */
  withTestId?: boolean;
};

/**
 * ページ内の登録導線。ログイン状態でボタンの文言と遷移先を出し分ける。
 * 未ログイン時の遷移先はアカウント登録画面のままにする（登録方法の選択肢を残すため）。
 */
export function HomeCta({
  authToken,
  withLoginLink = false,
  withTestId = false,
}: Props) {
  // 判定方法は変更前の Home.tsx・AuthProvider と揃える（空文字は未ログイン扱い）
  const isLoggedIn = Boolean(authToken);

  return (
    <div className={classes.ctaGroup}>
      <Button
        component={Link}
        href={isLoggedIn ? "/work" : "/signup"}
        radius="xl"
        size="lg"
        color={HOME_BRAND_COLOR}
        className={classes.ctaButton}
        rightSection={<ArrowForwardIcon color="white" />}
        data-testid={withTestId ? "link-to-verification" : undefined}
      >
        {isLoggedIn ? "お仕事を探す" : "今すぐ無料で登録する"}
      </Button>
      {!isLoggedIn && withLoginLink && (
        <Link href="/signup" className={classes.loginLink}>
          アカウントをお持ちの方はこちら（ログイン）
        </Link>
      )}
    </div>
  );
}
